@if (entryData().isComplex === false) {
  <div>
    <app-foldseek-table
      [afdb_accession]="afdb_accession"
      [accession]="accession"
    ></app-foldseek-table>
    @if(providerData().providerName === 'Google DeepMind'){
      <div class="sectionContent"></div>
      <app-cluster-table
        [accession]="accession" [uniprotAccession]="uniprotAccession">
      </app-cluster-table>
    }
  </div>
}
@if (entryData().isComplex === true) {
  <div>
    <div class="no-domain-parent" >
      <div class="no-domain-information">No information available</div>
      <div class="no-domain-notes">Similar proteins will appear here as new data is added in future updates.</div>
    </div>
  </div>
}






